export default {
  // 検索エリア
  sn: '当選番号',
  snPlaceholder: '当選番号を入力してください',
  code_sn: 'QRコード',
  code_snPlaceholder: 'QRコードを入力してください',
  member_keyword: 'ユーザー情報',
  member_keywordPlaceholder: 'ユーザー名またはIDを入力',
  activity_keyword: 'アクティビティ情報',
  activity_keywordPlaceholder: 'アクティビティ名またはIDを入力',
  status: '受取ステータス',
  statusPlaceholder: '選択してください',
  statusPendingShip: '発送待ち',
  statusCompleted: '完了',
  statusFailed: '配布失敗',
  statusShipped: '発送済み（受取待ち）',
  statusUnclaimed: '未受取',
  search: '検索',
  // テーブル列
  colSn: '当選番号',
  colCodeSn: '製品シリアルコード',
  colUserInfo: 'ユーザー情報',
  colActivityInfo: 'アクティビティ情報',
  colGiftName: 'ギフト名',
  colGiftNum: '数量',
  colMarketPrice: '市場価格',
  colPhone: '連絡先電話',
  colAddress: '配送先住所',
  colStatus: '受取ステータス',
  colCreatedAt: '作成日時',
  colAction: '操作',
  // 操作
  ship: '発送',
  shipInfo: '発送情報',
  // プレースホルダー
  dash: '——',
  none: 'なし',
  copySuccess: 'コピーしました',
  copyFailed: 'コピーに失敗しました',
  // 発送モーダル
  shipTitle: '発送',
  expressCompany: '配送会社',
  expressCompanyPlaceholder: '配送会社名を入力してください',
  expressCompanyRequired: '配送会社名を入力してください',
  expressNo: '追跡番号',
  expressNoPlaceholder: '追跡番号を入力してください',
  expressNoRequired: '追跡番号を入力してください',
  expressTime: '発送時間',
  ok: '確定',
  cancel: 'キャンセル',
  // 発送情報モーダル
  shipInfoTitle: '発送情報',
  // 空状態
  emptyText: 'ギフト受取記録がありません',
};
